// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Robm0","right":"Footer_right__-NV-0","buttons":"Footer_buttons__2ZQSt"};